module.exports = __webpack_public_path__ + "static/spacejams-84f35cf8640875ae60221e3a1846eaa3.jpg";